// extracted by mini-css-extract-plugin
module.exports = {"contacts":"styles_contacts__1hyzR","header":"styles_header__eomz_","contact":"styles_contact__1Xosu","link":"styles_link__18_Df"};